import { useContext } from 'react'

import { ItemsContext } from './context'

export const useSelectedItemsList = () => {
  return useContext(ItemsContext)
}
